import axios from "axios";
import { orderLoop } from "./GlobalVariables";
import { listCloneBetHomeModeLive } from "./GlobalVariables";
import Cookies from "js-cookie";

const normalizeText = (text) =>
  text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

function replaceLatinLetters(text) {
  const textModified = normalizeText(text);
  return textModified;
}

function urlPathAlongWithParam(url) {
  const urlObject = new URL(url);
  const pathWithParams = urlObject.pathname + urlObject.search;
  return pathWithParams;
}

function urlPathAlongWithParam2(url) {
  // eslint-disable-next-line
  const path = url.replace(/^https?:\/\/[^\/]+/, "");
  return path;
}

function decodeIdBolsaDeApostas(url) {
  const parsedUrl = new URL(url);
  const path = parsedUrl.pathname;
  return path;
}

function clonerBetnacional(baseUrl, url) {
  const urlPathParam = urlPathAlongWithParam(url);
  const newURLBetHome = `${baseUrl}${urlPathParam}`;
  return newURLBetHome;
}

function clonerSportingBet(baseUrl, url) {
  const urlPathParam = urlPathAlongWithParam(url);
  const newURLBetHome = `${baseUrl}${urlPathParam}`;
  return newURLBetHome;
}

function clonerBetBra(baseUrl, url) {
  const urlPathParam = decodeIdBolsaDeApostas(url);

  let newURLBetHome = `${baseUrl}${urlPathParam}`.replace("?affid=XvHshW", "");

  if (newURLBetHome.includes("matchbook.bet.br") === true) {
    let newURLBetHomeMofied = newURLBetHome
      .replace("/sport/", "/")
      .replace("/event/", "/");
    let indexMarket = newURLBetHomeMofied.toLowerCase().indexOf("/market/");
    if (indexMarket !== -1) {
      newURLBetHomeMofied = newURLBetHomeMofied.slice(0, indexMarket);
    }
    newURLBetHome = newURLBetHomeMofied;
  }
  return newURLBetHome;
}

function clonerPinnacles(baseUrl, url) {
  const urlPathParam = urlPathAlongWithParam(url);

  const newURLBetHome = `${baseUrl}${urlPathParam}`
    .replace("pt/", "pt/standard/")
    .replace("en/", "pt/standard/");
  return newURLBetHome;
}

function vbetUrlKeyPointLink(vbetUrl, isLiveSurebet) {
  try {
    const vbet = new URL(vbetUrl);
    const vbetParts = vbet.pathname.split("/");

    const sportIndex =
      vbetParts.findIndex(
        (part) => part === (isLiveSurebet ? "live" : "sport"),
      ) + 1;
    if (sportIndex <= 0 || sportIndex + 3 > vbetParts.length) {
      throw new Error("Unexpected vbet URL format");
    }

    const sportPath = vbetParts.slice(sportIndex, sportIndex + 3).join("/");

    const eventId = vbetParts[sportIndex + 3];

    let keyPointUrl = [sportPath, eventId];

    return keyPointUrl;
  } catch (error) {
    return [];
  }
}

function vbetUrlKeyPointLinkE_sport(url, isLiveSurebet) {
  try {
    const parsedUrl = new URL(url);
    const pathParts = parsedUrl.pathname.split("/");

    const sportIndex = pathParts.lastIndexOf(isLiveSurebet ? "live" : "sport");

    const game = pathParts[sportIndex + 1] || null;

    const eventIdMatch = parsedUrl.pathname.match(/(\d+)(?!.*\d)/);
    const eventId = eventIdMatch ? eventIdMatch[1] : null;

    return { game, eventId };
  } catch (err) {
    return { game: null, eventId: null };
  }
}

function commonLinkCreatorVbet(dataClone, url, isLiveSurebet) {
  let newURLBetHome = "";
  const fragmentsUrlVbet = vbetUrlKeyPointLink(url, isLiveSurebet);

  if (fragmentsUrlVbet.length > 0) {
    if (dataClone["baseURL"].indexOf("xxxxxxxxxxx-xxxxx-x") !== -1) {
      let a = dataClone["baseURL"]
        .replace("Soccer/Brazil/1792", fragmentsUrlVbet[0])
        .replace("27656663", fragmentsUrlVbet[1]);
      newURLBetHome = a;
    } else {
      let a = `${dataClone["baseURL"]}/${fragmentsUrlVbet[0]}/${fragmentsUrlVbet[1]}`;
      newURLBetHome = a;
    }
  } else {
    const linkHome = new URL(dataClone["baseURL"]).origin;
    newURLBetHome = linkHome;
  }

  return newURLBetHome;
}

function cloneVbet(dataClone, url, isLiveSurebet) {
  const listE_sportsVbetException = [
    "Valorant",
    "LeagueOfLegends",
    "CounterStrike",
    "Dota2",
    "RocketLeague",
    "RainbowSix",
  ];

  let newURLBetHome = "";

  const hasException = listE_sportsVbetException.some((game) =>
    url.includes(game),
  );

  if (hasException === true && dataClone["e_sportBaseURL"] !== undefined) {
    const { game, eventId } = vbetUrlKeyPointLinkE_sport(url, isLiveSurebet);
    let linkE_sport = dataClone["e_sportBaseURL"];

    if (game !== null && eventId !== null) {
      let newLinkE_sport = linkE_sport
        .replace("xxe-sportxx", game)
        .replace("xxidzz", eventId);
      newURLBetHome = newLinkE_sport;
    } else {
      const linkHome = new URL(dataClone["baseURL"]).origin;
      newURLBetHome = linkHome;
    }
  } else if (
    hasException === true &&
    (dataClone["baseURL"].includes("www.seu.bet.br") === true ||
      dataClone["baseURL"].includes("www.h2.bet.br") === true)
  ) {
    newURLBetHome = commonLinkCreatorVbet(dataClone, url, isLiveSurebet);
  } else if (
    hasException === true &&
    dataClone["e_sportBaseURL"] === undefined
  ) {
    const linkHome = new URL(dataClone["baseURL"]).origin;
    newURLBetHome = linkHome;
  } else {
    newURLBetHome = commonLinkCreatorVbet(dataClone, url, isLiveSurebet);
  }
  return newURLBetHome;
}

function decodeUrlBetFast(domain) {
  const indexPrematch = domain.indexOf("prematch?match=");
  const restUrl = domain.slice(indexPrematch);
  return restUrl;
}

function clonerBetFast(baseUrl, url) {
  if (baseUrl.includes("www.brazino777.bet.br") === true) {
    return baseUrl;
  }

  const urlPathParam = decodeUrlBetFast(url);
  const newURLBetHome = `${baseUrl}${urlPathParam}`;
  if (baseUrl.includes("faz1.bet.br") === true) {
    let urlFaz1Bet = newURLBetHome.replace(
      "prematch?match=",
      "br/sportsbook/prematch#/prematch/match/",
    );
    return urlFaz1Bet;
  }
  return newURLBetHome;
}

function genericClonerBetHome(baseURLClone, url) {
  const partUrl = urlPathAlongWithParam2(url);
  const urlClone = `${baseURLClone}${partUrl}`;
  return urlClone;
}

function clonerStake(baseURLClone, url) {
  if (baseURLClone.includes("betwarrior") === true) {
    let last_cc_fragmented = url.split("/");
    let id_surebet = last_cc_fragmented[last_cc_fragmented.length - 1];

    return `${baseURLClone}/${id_surebet}`;
  } else if (baseURLClone.includes("reidopitaco") === true) {
    return baseURLClone;
  }
  let link_clone = genericClonerBetHome(baseURLClone, url);
  let link_clone_remade = replaceLatinLetters(
    link_clone.replaceAll("--", "-").replaceAll("--", "---"),
  );

  return link_clone_remade;
}

function clonerStakeModeLive(baseURLClone, url) {
  if (baseURLClone.includes("betwarrior") === true) {
    let last_cc_fragmented = url.split("/");
    let id_surebet = last_cc_fragmented[last_cc_fragmented.length - 1];

    return `${baseURLClone}/${id_surebet}`;
  } else if (baseURLClone.includes("reidopitaco") === true) {
    return baseURLClone;
  }
  let link_clone = genericClonerBetHome(baseURLClone, url);
  let link_clone_remade = replaceLatinLetters(
    link_clone.replaceAll("--", "-").replaceAll("--", "---"),
  );

  return link_clone_remade.replace("/esportes/", "/esportes-ao-vivo/");
}

function clonerEstrelaBet(baseURLClone, url) {
  const partUrl = urlPathAlongWithParam2(url);
  let link_clone = `${baseURLClone}${partUrl}`.replace(
    "/pb/esportes",
    "/pt/sports",
  );

  link_clone = baseURLClone.includes(".vupi.")
    ? link_clone.replace("eventid", "eventId")
    : link_clone;
  return link_clone;
}

function clonerBlaze(baseURLClone, url) {
  let urlCloneBlaze = genericClonerBetHome(baseURLClone, url);

  if (
    urlCloneBlaze.includes("pin.bet.br") === true ||
    urlCloneBlaze.includes("bingo.bet.br") === true
  ) {
    urlCloneBlaze = urlCloneBlaze.replace(
      "en/sports?bt-path",
      "sports?bt-path",
    );
  } else if (
    urlCloneBlaze.includes("betboom.bet.br") === true ||
    urlCloneBlaze.includes("zonadejogo.bet.br") === true ||
    urlCloneBlaze.includes("apostaonline.bet.br") === true ||
    urlCloneBlaze.includes("onlybets.bet.br") === true ||
    urlCloneBlaze.includes("xx.bet.br") === true
  ) {
    urlCloneBlaze = decodeURIComponent(
      urlCloneBlaze.replace("/en/sports?bt-path=", ""),
    );
  } else if (urlCloneBlaze.includes("afun.bet.br") === true) {
    urlCloneBlaze = decodeURIComponent(
      urlCloneBlaze.replace("/en/sports?bt-path=", ""),
    );
    let fragmenturl = urlCloneBlaze.indexOf("sports");
    if (fragmenturl !== -1) {
      let restUrl = urlCloneBlaze.slice(fragmenturl);
      let restUrlSplited = restUrl.split("/");
      let indexSportUrlSplited = restUrlSplited.indexOf("sports");
      if (restUrlSplited[indexSportUrlSplited + 1] !== undefined) {
        restUrlSplited[indexSportUrlSplited + 1] = "x";
      }
      restUrl = restUrlSplited.join("/");
      urlCloneBlaze = urlCloneBlaze.slice(0, fragmenturl) + restUrl;
    }
  }
  return urlCloneBlaze;
}

function clonerHiperBet(baseUrl, url) {
  const urlPathParam = urlPathAlongWithParam(url);
  let newURLBetHome = `${baseUrl}${urlPathParam}`;

  if (baseUrl.includes("oleybet.bet.br") === true) {
    let newURLBetHomeModified = newURLBetHome.replace("/en/", "ptb/");
    newURLBetHome = newURLBetHomeModified;
  }

  return newURLBetHome;
}

export function managerFunctionCloneBetHome(
  infoBetHome,
  baseBethomeClone,
  nameCloneBetHome,
  url,
  isLiveSurebet = false,
) {
  const managerClonerBetHome = {
    hiperbet: function () {
      return clonerHiperBet(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    sportingbet: function () {
      return clonerSportingBet(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    betnacional: function () {
      let linkFragmented = url.split("/");
      let idLink =
        linkFragmented.length - 1 > 1
          ? linkFragmented[linkFragmented.length - 1]
          : "";

      if (
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"].includes(
          "match:",
        ) === true
      ) {
        return `${infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"]}${idLink}`;
      }
      return clonerBetnacional(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    estrelabet: function () {
      if (
        ["sorteonline", "lottoland", "pagol"].includes(nameCloneBetHome) ===
        true
      ) {
        const parsedUrl = new URL(url);
        const queryString = parsedUrl.search;
        return `${infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"]}${queryString}`;
      } else if (
        [
          "br4",
          "goldebet",
          "lotogreen",
          "esportivabet",
          "aposta1",
          "mcgames",
          "bateubet",
          "multibet",
          "upbet",
          "betfusion",
          "cassino",
          "brasildasorte",
          "brbet",
          "jogodeouro",
          "onabet",
          "f12bet",
          "aviaobet",
          "apostou",
          "vaidebet",
          "betpix365",
          "4play",
          "ginga.bet",
          "playbet",
          "cbesportes",
          "donosdabola",
          "esportivavip",
          "luvabet",
          "startbet",
        ].includes(nameCloneBetHome) === true
      ) {
        const parsedUrl = new URL(url.toLowerCase().toLowerCase());
        const params = new URLSearchParams(parsedUrl.search);

        const eventId = params.get("eventid");

        return `${infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"]}${eventId}`;
      }

      return clonerEstrelaBet(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    "bet-bra": function () {
      return clonerBetBra(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    pinnacle: function () {
      return clonerPinnacles(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    vbet: function () {
      if (isLiveSurebet === true) {
        return cloneVbet(
          listCloneBetHomeModeLive[baseBethomeClone][nameCloneBetHome],
          url,
          isLiveSurebet,
        );
      }
      return cloneVbet(
        infoBetHome[baseBethomeClone][nameCloneBetHome],
        url,
        isLiveSurebet,
      );
    },
    betfast: function () {
      return clonerBetFast(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    f12bet: function () {
      return genericClonerBetHome(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    bet7k: function () {
      let urlBetHome = genericClonerBetHome(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );

      if (
        [
          "lider",
          "bet-bra sb",
          "betdásorte",
          "ice.bet",
          "kingpanda",
          "mmabet",
          "bravobet",
        ].includes(nameCloneBetHome) === true
      ) {
        const ulrFragmented = url.toString().split("/");
        const lastIndex = ulrFragmented.length - 1;
        let idUrl = ulrFragmented[lastIndex];
        idUrl = idUrl.replace("e-", "");

        return `${infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"]}/${idUrl}`;
      } else if (["Ganheibet", "brabet"].includes(nameCloneBetHome) === true) {
        urlBetHome = urlBetHome.replace("/esportes/", "/sports/");
      } else if (["betvip"].includes(nameCloneBetHome) === true) {
        let urlSplited = urlBetHome.split("/");
        let lastIndexUrlSplited = urlSplited.length - 1;
        let lastItem = urlSplited[lastIndexUrlSplited];
        let newUrl =
          infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"] +
          "/" +
          lastItem;
        urlBetHome = newUrl;
      } else if (
        ["bigbet", "tradicional"].includes(nameCloneBetHome) === true
      ) {
        urlBetHome = urlBetHome
          .replace("/esportes/", "/")
          .replace("/sports/", "/")
          .replace("/e-", "/");
      }
      return urlBetHome;
    },
    stake: function () {
      if (isLiveSurebet === true) {
        return clonerStakeModeLive(
          listCloneBetHomeModeLive[baseBethomeClone][nameCloneBetHome][
            "baseURL"
          ],
          url,
        );
      }
      return clonerStake(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    blaze: function () {
      return clonerBlaze(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    betesporte: function () {
      return genericClonerBetHome(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    "bolsadeaposta sb": function () {
      return genericClonerBetHome(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    vivasorte: function () {
      return genericClonerBetHome(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    betão: function () {
      return genericClonerBetHome(
        infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"],
        url,
      );
    },
    marjosports: function () {
      return infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"];
    },
    esportesdasorte: function () {
      return infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"];
    },
    betrebels: function () {
      const parsedUrl = new URL(url.toLowerCase().toLowerCase());
      const params = new URLSearchParams(parsedUrl.search);

      const eventId = params.get("eventid");
      let newURL = infoBetHome[baseBethomeClone][nameCloneBetHome][
        "baseURL"
      ].replace("17487543", eventId);
      return newURL;
    },
    mystake: function () {
      let urlFragmented = url.split("/");
      let lastUrlItem = urlFragmented.slice(-1);
      let newURL = infoBetHome[baseBethomeClone][nameCloneBetHome][
        "baseURL"
      ].replace("76146368", lastUrlItem);
      return newURL;
    },
    fortunejack: function () {
      let urlFragmented = url.split("-");
      let lastUrlItem = urlFragmented.slice(-1);
      let newURL = infoBetHome[baseBethomeClone][nameCloneBetHome][
        "baseURL"
      ].replace("2710598317431197731", lastUrlItem);
      return newURL;
    },
    piwi247: function () {
      try {
        let urlFragmented = url.split("/");
        let lastUrlItem = urlFragmented.slice(-1)[0];

        const isNumber =
          lastUrlItem.trim() !== "" && Number.isFinite(Number(lastUrlItem));

        if (isNumber === true && nameCloneBetHome === "ps3838") {
          return `https://www.ps3838.com/pt/sports/XXXXXX/matchup/xx-xx-xx/xxx-xxx-xxx/1234/${lastUrlItem}`;
        } else {
          return infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"];
        }
      } catch {}
      return infoBetHome[baseBethomeClone][nameCloneBetHome]["baseURL"];
    },
  };

  let valueReturn = managerClonerBetHome[baseBethomeClone]();

  return valueReturn;
}

export async function statusUserCoupon(email) {
  const dataToSend = { e6245: email };
  const response = await fetch(`https://arbitragem.bet:9456/can_use_coupon`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(dataToSend),
  });

  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}

export async function checkLogin(skipReload = false) {
  const b4726486 = Cookies.get("b4726486");

  const dataToSend = { b4726486: b4726486 };
  const response = await fetch(
    "https://arbitragem.bet:3131/user/check_login/",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(dataToSend),
    },
  );

  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    if (!skipReload) {
      localStorage.clear();
      Cookies.remove("b4726486");
      window.location.href = "/";
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return false;
  }
}

export async function logoutUser() {
  const b4726486 = Cookies.get("b4726486");

  localStorage.clear();
  Cookies.remove("b4726486");

  const dataToSend = { b4726486: b4726486 };
  const response = await fetch("https://arbitragem.bet:3131/user/logout/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(dataToSend),
  });

  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    window.location.href = "/";
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}

//---FILTER
export function updateClassifiactionSurebet(
  nameClassification,
  setStateClassification,
  nameLocalStorage,
) {
  const nameClassificationLower = nameClassification.toLowerCase();
  setStateClassification(nameClassificationLower);
  localStorage.setItem(
    nameLocalStorage,
    JSON.stringify(nameClassificationLower),
  );
}

//---LocalStorage

export function localStorageManagerReturn(nameLocalStorage, defaultValue) {
  let itemLocalStorage = localStorage.getItem(nameLocalStorage);

  try {
    return JSON.parse(itemLocalStorage);
  } catch {
    return defaultValue;
  }
}

export function organizatorSurebetByClassification(statusFilter, dataSurebet) {
  if (statusFilter === "início") {
    let newDataSurebet = {};
    let keysObject = Object.keys(dataSurebet);
    let gcc = {};
    for (let i = 0; i < keysObject.length; i++) {
      let keyObject = keysObject[i];
      let valueObject = dataSurebet[keyObject]["main"];
      let listLargeTime = [];

      for (let i_orderLoop = 0; i_orderLoop < orderLoop.length; i_orderLoop++) {
        let order = orderLoop[i_orderLoop];

        if (order in valueObject) {
          listLargeTime.push(valueObject[order]["time_milliseconds"]);
        }
      }

      let listLargeTimeOrdenated = listLargeTime.sort();
      listLargeTimeOrdenated.reverse();

      if (gcc[listLargeTimeOrdenated[0]] === undefined) {
        gcc[listLargeTimeOrdenated[0]] = [keyObject];
      } else {
        gcc[listLargeTimeOrdenated[0]].push(keyObject);
      }
    }

    let keysGcc = Object.keys(gcc);
    let keysGccOrdenated = keysGcc.sort();

    for (let i = 0; i < keysGccOrdenated.length; i++) {
      let keyGccOrdenated = keysGccOrdenated[i];

      for (
        let i_gccItem = 0;
        i_gccItem < gcc[keyGccOrdenated].length;
        i_gccItem++
      ) {
        let item = gcc[keyGccOrdenated][i_gccItem];
        newDataSurebet[item] = dataSurebet[item];
      }
    }

    return newDataSurebet;
  } else if (statusFilter === "recentes") {
    let newDataSurebet = {};
    let keysObject = Object.keys(dataSurebet);
    let gcc = {};
    let keysNumber = [];
    for (let i = 0; i < keysObject.length; i++) {
      let keyObject = keysObject[i];
      let valueObject = dataSurebet[keyObject]["main"];

      let timeLower = valueObject["time"].toLowerCase();

      let g =
        timeLower.indexOf("h") !== -1
          ? parseFloat(timeLower.replace("h", "")) * 60
          : timeLower.indexOf("dia") !== -1
            ? parseFloat(timeLower.replace("dias", "").replace("dia", "")) *
              1440
            : parseFloat(timeLower.replace("min", ""));

      if (gcc[g] === undefined) {
        gcc[g] = [keyObject];
        keysNumber.push(g);
      } else {
        gcc[g].push(keyObject);
      }
    }

    let keysGccOrdenated = keysNumber.sort((a, b) => a - b);

    for (let i = 0; i < keysGccOrdenated.length; i++) {
      let keyGccOrdenated = keysGccOrdenated[i].toString();

      for (
        let i_gccItem = 0;
        i_gccItem < gcc[keyGccOrdenated].length;
        i_gccItem++
      ) {
        let item = gcc[keyGccOrdenated][i_gccItem];
        newDataSurebet[item] = dataSurebet[item];
      }
    }

    return newDataSurebet;
  } else {
    return dataSurebet;
  }
}

export function decodeChance(chance_surebet) {
  let valueToReturn = {
    chance: 0,
    percent: 0,
  };

  let hasStart = chance_surebet.indexOf("(");

  if (hasStart !== -1 && hasStart !== -1) {
    let chanceFragmented = chance_surebet.split("(");
    let realChance = Number(chanceFragmented[0]);
    let percentChance = Number(
      chanceFragmented[1]
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(",", ".")
        .replaceAll("%", ""),
    );

    valueToReturn["chance"] = realChance;
    valueToReturn["percent"] = percentChance;

    return valueToReturn;
  }
  valueToReturn["chance"] = Number(chance_surebet);
  return valueToReturn;
}

export async function checkSessiondID(sessionIDs) {
  if (sessionIDs) {
    const concurrentLoginResponse = await axios.post(
      "https://rd.vps.webdock.cloud:9512/api/check-concurrent-session",
      {
        userID: sessionIDs,
      },
    );
    const checkdata = await concurrentLoginResponse.data.concurrentLogin;
    if (!checkdata) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
}

export function createListBetHomeDemarkOnFilter(clonerBetHomeJSON) {
  const clonerBetHome = JSON.parse(clonerBetHomeJSON);
  const newListBetHomeDemarkOnFilter = clonerBetHome["allBetHomeAbleToClone"]
    .map((item) => {
      let listBetHome = clonerBetHome[item]["allBetHomeClone"];
      listBetHome.push(item);
      return listBetHome;
    })
    .concat(["sportingbet", "betboo"]);
  return newListBetHomeDemarkOnFilter;
}

export function isValidEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

export function deduplicateArray(paramArray) {
  return [...new Set(paramArray)];
}
